(function () {
  const ROOT_CLASS = 'has-header-hero-slideshow';
  const SOLID_CLASS = 'is-hero-header-solid';
  const PINNED_CLASS = 'is-hero-header-pinned';
  const TRANSTORE_MOBILE_SELECTOR = '.header-hero-slideshow__header #ts-switcher-manual-mobile';
  const TRANSTORE_DESKTOP_SELECTOR =
    '.header-hero-slideshow__header #ts-switcher-manual-desktop, .header-hero-slideshow__header .header-hero-transtore-slot.small-hide';
  const MEGA_PANEL_SELECTOR =
    '[class*="tmenu_submenu"], [class*="tmenu-sub-menu"], [class*="tmenu_sub"], [class*="tmenu-sub"], [class*="tmenu_dropdown"], [class*="tmenu-dropdown"], [class*="tmenu_mega"], [class*="tmenu-mega"], [class*="tmenu_popup"], [class*="tmenu-popup"]';

  function safeAppendChild(parent, child) {
    if (!parent || !child || parent === child) return false;
    if (parent.contains(child)) return false;
    if (child.contains(parent)) return false;
    parent.appendChild(child);
    return true;
  }

  function findTmenuWrapper(root) {
    return root?.querySelector?.('.tmenu_wrapper, [class*="tmenu_wrapper"]') || null;
  }

  function findTmenuWrapperInDocument(section) {
    const roots = [
      section.querySelector('.header-hero-slideshow__header .header__inline-menu .list-menu--inline'),
      section.querySelector('.header-hero-slideshow__header .menu-drawer__menu'),
      document.querySelector('.section-header .list-menu.list-menu--inline'),
      document.querySelector('.section-header .menu-drawer__menu'),
      section.querySelector('.header-hero-slideshow__header'),
      document.querySelector('.section-header'),
    ].filter(Boolean);

    for (const root of roots) {
      const tmenu = findTmenuWrapper(root);
      if (tmenu) return { tmenu, root };
    }

    const tmenu = document.querySelector(
      '.header-hero-slideshow__header [class*="tmenu_wrapper"], .section-header [class*="tmenu_wrapper"]'
    );
    if (tmenu) return { tmenu, root: tmenu.parentElement };

    return null;
  }

  function relocateQikifyMenu(section) {
    const heroUl = section.querySelector('.header-hero-slideshow__header .list-menu.list-menu--inline');
    if (!heroUl) return false;

    if (findTmenuWrapper(heroUl)) return true;

    const found = findTmenuWrapperInDocument(section);
    if (!found) return false;

    safeAppendChild(heroUl, found.tmenu);

    const inlineMenu = section.querySelector('.header-hero-slideshow__header .header__inline-menu');
    if (inlineMenu) {
      inlineMenu.hidden = false;
      inlineMenu.style.removeProperty('display');
    }

    window.dispatchEvent(new CustomEvent('SETUP_MEGAMENU'));
    return true;
  }

  function getTranstoreNodes(heroHeader) {
    const nodes = new Set();
    heroHeader?.querySelectorAll('.ts-switcher-btn').forEach((btn) => {
      nodes.add(btn.closest('.shopify-app-block, .ts-theme, .ts-switcher') || btn);
    });
    return Array.from(nodes);
  }

  function getHeroTranstoreSlots(heroIcons) {
    return {
      mobile:
        heroIcons.querySelector('#ts-switcher-manual-mobile') ||
        heroIcons.querySelector('.hero-transtore-anchor-mobile') ||
        heroIcons.querySelector('[data-header-transtore-slot]:not(.small-hide)'),
      desktop:
        heroIcons.querySelector('.header-hero-transtore-slot.small-hide') ||
        heroIcons.querySelector('[data-header-hero-transtore-slot].small-hide') ||
        heroIcons.querySelector('#ts-switcher-manual-desktop'),
    };
  }

  function hideTranstoreSlot(slot) {
    if (!slot) return;
    slot.hidden = true;
    slot.setAttribute('aria-hidden', 'true');
    slot.style.setProperty('display', 'none', 'important');
  }

  function showTranstoreSlot(slot) {
    if (!slot) return;
    slot.hidden = false;
    slot.removeAttribute('aria-hidden');
    slot.style.removeProperty('display');
    slot.style.removeProperty('width');
    slot.style.removeProperty('height');
    slot.style.removeProperty('overflow');
  }

  function moveTranstoreNodesToTarget(heroHeader, target, nodes) {
    if (!heroHeader || !target) return false;

    let moved = false;
    nodes.forEach((node) => {
      if (!heroHeader.contains(node) || target.contains(node)) return;
      if (safeAppendChild(target, node)) moved = true;
    });
    return moved;
  }

  function restoreHeroDesktopLayout(section) {
    const heroHeader = section.querySelector('.header-hero-slideshow__header');
    const header = heroHeader?.querySelector('.header');
    const inlineMenu = heroHeader?.querySelector('.header__inline-menu');
    const search = heroHeader?.querySelector('.header__search');

    if (search) search.style.removeProperty('display');
    if (inlineMenu) {
      inlineMenu.hidden = false;
      inlineMenu.style.removeProperty('display');
    }

    if (header) {
      header.style.removeProperty('display');
      header.style.removeProperty('flex-wrap');
      header.style.removeProperty('align-items');
      header.style.removeProperty('justify-content');
      header.style.removeProperty('grid-template-areas');
      header.style.removeProperty('grid-template-columns');
      header.style.removeProperty('padding');
      header.style.removeProperty('min-height');
      header.style.removeProperty('gap');
    }

    heroHeader?.querySelectorAll('.header__heading, .header__heading-link').forEach((el) => {
      el.style.removeProperty('position');
      el.style.removeProperty('order');
      el.style.removeProperty('flex');
      el.style.removeProperty('transform');
      el.style.removeProperty('left');
      el.style.removeProperty('top');
    });
  }
  function getTranstoreMountNode(icons) {
    if (!icons) return null;

    if (isHeroMobileHeader()) {
      return (
        icons.querySelector('#ts-switcher-manual-mobile') ||
        icons.querySelector('[data-header-transtore-slot]:not(.small-hide)') ||
        icons.querySelector('[data-header-transtore-slot]') ||
        icons
      );
    }

    return (
      icons.querySelector('#ts-switcher-manual-desktop') ||
      icons.querySelector('.header-hero-transtore-slot.small-hide') ||
      icons.querySelector('[data-header-hero-transtore-slot].small-hide') ||
      icons.querySelector('[data-header-transtore-slot]') ||
      icons
    );
  }

  function getHeroTranstoreNode(scope) {
    if (!scope) return null;
    const btn = scope.querySelector('.ts-switcher-btn');
    if (!btn) return null;
    return btn.closest('.shopify-app-block, .ts-theme, .ts-switcher') || btn;
  }

  function moveToEndIfNeeded(parent, child) {
    if (!parent || !child || child.parentElement !== parent) return false;
    if (parent.lastElementChild === child) return false;
    parent.appendChild(child);
    return true;
  }

  function ensureHeroMobileSearch(section) {
    if (!isHeroMobileHeader()) return;

    const heroIcons = section.querySelector('.header-hero-slideshow__header .header__icons');
    if (!heroIcons) return;

    const search = heroIcons.querySelector('.header__search');
    if (search) {
      search.style.setProperty('display', 'inline-flex', 'important');
    }
  }

  function scheduleTranstoreRelocation(section) {
    if (!section || isHeroMobileHeader()) return;
    if (section.dataset.transtoreRelocationScheduled === 'true') return;
    section.dataset.transtoreRelocationScheduled = 'true';

    function syncTranstore() {
      relocateTranstoreSwitcher(section);
    }

    syncTranstore();

    [100, 400, 800, 1500, 3000, 5000, 8000, 12000, 15000, 20000].forEach((delay) => {
      window.setTimeout(syncTranstore, delay);
    });

    const heroHeader = section.querySelector('.header-hero-slideshow__header');
    if (heroHeader && heroHeader.dataset.transtoreWatch !== 'true') {
      heroHeader.dataset.transtoreWatch = 'true';
      new MutationObserver(() => {
        window.clearTimeout(section._transtoreRelocateTimer);
        section._transtoreRelocateTimer = window.setTimeout(syncTranstore, 50);
      }).observe(heroHeader, { childList: true, subtree: true });
    }

    if (document.body.dataset.transtoreBodyWatch !== 'true') {
      document.body.dataset.transtoreBodyWatch = 'true';
      new MutationObserver(() => {
        if (!document.querySelector('.header-hero-slideshow__header .ts-switcher-btn')) return;
        window.clearTimeout(section._transtoreBodyTimer);
        section._transtoreBodyTimer = window.setTimeout(syncTranstore, 50);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  function syncCartIconId(section) {
    const heroCart = section.querySelector('.header-hero-slideshow__header .header__icon--cart');
    const defaultCart = document.querySelector('.section-header .header__icon--cart');
    if (!heroCart) return;

    if (isHeroMobileHeader()) {
      if (heroCart.id !== 'cart-icon-bubble') heroCart.id = 'cart-icon-bubble';
      if (defaultCart && defaultCart.id !== 'cart-icon-bubble-default') defaultCart.id = 'cart-icon-bubble-default';
      return;
    }

    if (heroCart.id !== 'cart-icon-bubble') heroCart.id = 'cart-icon-bubble';
    if (defaultCart && defaultCart.id !== 'cart-icon-bubble-default') defaultCart.id = 'cart-icon-bubble-default';
  }

  function initMobileHeroHeader(section) {
    syncCartIconId(section);
  }

  function relocateSearchIcon(section) {
    const heroIcons = section.querySelector('.header-hero-slideshow__header .header__icons');
    if (!heroIcons || heroIcons.querySelector('.header__search')) return;

    const globalSearch =
      document.querySelector('.section-header .header__icons .header__search') ||
      document.querySelector('.section-header .header > .header__search');

    if (!globalSearch || heroIcons.contains(globalSearch)) return;
    if (globalSearch.contains(heroIcons)) return;

    const firstUtility = heroIcons.querySelector('.header__icon--account, .shopify-app-block, .header__icon--cart');
    if (firstUtility) {
      heroIcons.insertBefore(globalSearch, firstUtility);
    } else {
      heroIcons.prepend(globalSearch);
    }
  }

  function revealTranstoreMount(mount) {
    if (!mount?.querySelector('.ts-switcher-btn')) return;
    mount.hidden = false;
    mount.style.removeProperty('display');
    mount.style.removeProperty('width');
    mount.style.removeProperty('height');
  }

  function revealManualTranstoreAnchors(heroIcons, mount) {
    if (!heroIcons || mount?.querySelector('.ts-switcher-btn')) return;

    heroIcons.querySelectorAll('.hero-transtore-anchor-mobile, .hero-transtore-anchor-desktop, #ts-switcher-manual-mobile, #ts-switcher-manual-desktop').forEach((anchor) => {
      if (!isHeroMobileHeader() && anchor.classList.contains('hero-transtore-anchor-mobile')) return;
      if (isHeroMobileHeader() && anchor.classList.contains('hero-transtore-anchor-desktop')) return;
      if (!anchor.querySelector('.ts-switcher-btn')) return;

      anchor.hidden = false;
      anchor.classList.remove('visually-hidden');
      anchor.style.removeProperty('display');
      anchor.style.removeProperty('width');
      anchor.style.removeProperty('height');
      anchor.style.removeProperty('overflow');
      anchor.style.removeProperty('clip');
    });
  }

  function scoreTranstoreButton(btn, mount) {
    let score = mount?.contains(btn) ? 100 : 0;
    score += (btn.textContent || '').replace(/\s+/g, '').length;
    if (btn.querySelector('.ts-switcher-btn__icon, .ts-country__icon')) score += 10;
    if (btn.querySelector('.ts-currency__name, .ts-switcher-btn__name, .ts-country__name')) score += 20;
    return score;
  }

  function dedupeHeroTranstore(heroHeader, mount) {
    const buttons = Array.from(heroHeader.querySelectorAll('.ts-switcher-btn'));
    if (buttons.length <= 1) return buttons[0] || null;

    buttons.sort((a, b) => scoreTranstoreButton(b, mount) - scoreTranstoreButton(a, mount));
    const primary = buttons[0];

    buttons.slice(1).forEach((btn) => {
      const host = btn.closest('.shopify-app-block, .ts-theme, .ts-switcher') || btn;
      host.style.setProperty('display', 'none', 'important');
      host.setAttribute('aria-hidden', 'true');
    });

    return primary;
  }

  function cleanupTranstoreAnchors(heroIcons, mount) {
    if (!heroIcons || isHeroMobileHeader()) return;

    heroIcons
      .querySelectorAll(':scope > .ts-switcher-btn__icon-arrow, :scope > .ts-currency__icon-arrow')
      .forEach((node) => node.remove());

    heroIcons.querySelectorAll('#ts-switcher-manual-desktop, .hero-transtore-anchor-desktop').forEach((anchor) => {
      if (anchor.querySelector('.ts-switcher-btn')) return;
      anchor.hidden = true;
      anchor.style.setProperty('display', 'none', 'important');
    });

    if (mount?.querySelector('.ts-switcher-btn')) {
      heroIcons.querySelectorAll('#ts-switcher-manual-desktop, .hero-transtore-anchor-desktop').forEach((anchor) => {
        anchor.hidden = true;
        anchor.style.setProperty('display', 'none', 'important');
      });
    }
  }

  function collectTranstoreNodes(scope) {
    if (!scope) return [];
    const nodes = new Set();
    scope.querySelectorAll('.ts-switcher-btn').forEach((btn) => {
      nodes.add(btn.closest('.shopify-app-block, .ts-theme, .ts-switcher') || btn);
    });
    return Array.from(nodes);
  }

  function moveTranstoreFromDefaultHeader(section, heroHeader, target) {
    if (!heroHeader || !target) return false;
    if (isHeroMobileHeader() && section?.dataset?.transtoreMobileMoved === 'true') return false;
    if (heroHeader.querySelector('.ts-switcher-btn')) {
      if (isHeroMobileHeader() && section) section.dataset.transtoreMobileMoved = 'true';
      return false;
    }

    const sources = [
      document.querySelector('.section-header [data-header-transtore-fallback]'),
      document.querySelector('.section-header [data-header-transtore-slot]'),
      document.querySelector('.section-header .header__icons'),
    ].filter(Boolean);

    let moved = false;
    sources.forEach((source) => {
      collectTranstoreNodes(source).forEach((node) => {
        if (target.contains(node)) return;
        if (safeAppendChild(target, node)) moved = true;
      });
    });

    if (moved && isHeroMobileHeader() && section) {
      section.dataset.transtoreMobileMoved = 'true';
    }

    return moved;
  }

  function revealMobileTranstoreHosts(heroIcons) {
    if (!heroIcons) return;

    heroIcons
      .querySelectorAll('.hero-transtore-anchor-mobile, #ts-switcher-manual-mobile, [data-header-hero-transtore-slot]')
      .forEach((host) => {
        if (!host.querySelector('.ts-switcher-btn, .ts-theme, .shopify-app-block')) return;
        host.hidden = false;
        host.removeAttribute('aria-hidden');
        host.style.removeProperty('display');
        host.style.removeProperty('width');
        host.style.removeProperty('height');
        host.style.removeProperty('overflow');
      });

    revealManualTranstoreAnchors(heroIcons, null);
  }

  function relocateTranstoreSwitcherMobile(section) {
    const heroHeader = section.querySelector('.header-hero-slideshow__header');
    const heroIcons = heroHeader?.querySelector('.header__icons');
    if (!heroHeader || !heroIcons) return;

    const slots = getHeroTranstoreSlots(heroIcons);
    const target = slots.mobile;
    if (!target) return;

    hideTranstoreSlot(slots.desktop);
    showTranstoreSlot(target);

    const nodes = getTranstoreNodes(heroHeader);
    moveTranstoreNodesToTarget(heroHeader, target, nodes);

    if (!heroHeader.querySelector('.ts-switcher-btn')) {
      moveTranstoreFromDefaultHeader(section, heroHeader, target);
    }

    revealMobileTranstoreHosts(heroIcons);
    revealTranstoreMount(target);
  }

  function relocateTranstoreSwitcher(section) {
    if (isHeroMobileHeader()) return;

    const heroHeader = section.querySelector('.header-hero-slideshow__header');
    const heroIcons = heroHeader?.querySelector('.header__icons');
    if (!heroHeader || !heroIcons) return;

    const slots = getHeroTranstoreSlots(heroIcons);
    const mount = slots.desktop || getTranstoreMountNode(heroIcons);
    if (!mount) return;

    hideTranstoreSlot(slots.mobile);
    showTranstoreSlot(mount);

    const nodes = getTranstoreNodes(heroHeader);
    moveTranstoreNodesToTarget(heroHeader, mount, nodes);
    moveTranstoreFromDefaultHeader(section, heroHeader, mount);

    function moveWithinHero(node) {
      if (!node || mount.contains(node)) return;
      if (node.closest('.section-header')) return;
      const target = node.closest('.shopify-app-block, .ts-theme, .ts-switcher') || node;
      if (!heroHeader.contains(target)) return;
      safeAppendChild(mount, target);
    }

    heroHeader.querySelectorAll('.ts-switcher-btn').forEach((btn) => {
      moveWithinHero(btn.closest('.shopify-app-block, .ts-theme, .ts-switcher') || btn);
    });

    heroIcons.querySelectorAll(':scope > .ts-switcher-btn, :scope > .ts-switcher, :scope > .ts-theme, :scope > .shopify-app-block').forEach((node) => {
      if (!node.querySelector?.('.ts-switcher-btn') && !node.classList?.contains('ts-switcher-btn')) return;
      moveWithinHero(node.classList?.contains('ts-switcher-btn') ? node : node.querySelector('.ts-switcher-btn') || node);
    });

    const primary = dedupeHeroTranstore(heroHeader, mount);
    if (primary && !mount.contains(primary)) {
      moveWithinHero(primary.closest('.shopify-app-block, .ts-theme, .ts-switcher') || primary);
    }

    cleanupTranstoreAnchors(heroIcons, mount);
    revealManualTranstoreAnchors(heroIcons, mount);
    revealTranstoreMount(mount);
  }

  function setupQikifyMenus(section) {
    if (!section) return;

    if (isHeroMobileHeader()) {
      window.dispatchEvent(new CustomEvent('SETUP_MOBILEMENU'));
      ensureHeroMobileSearch(section);
      syncCartIconId(section);
      bootAnchorQikifyMenus();
      syncHeroMobileMenu(section);
      relocateTranstoreSwitcherMobile(section);
      releaseHeroScrollLock();
      return;
    }

    window.dispatchEvent(new CustomEvent('SETUP_MEGAMENU'));
    window.dispatchEvent(new CustomEvent('SETUP_MOBILEMENU'));
    relocateQikifyMenu(section);
    relocateSearchIcon(section);
    relocateTranstoreSwitcher(section);
    initMobileHeroHeader(section);
    scheduleTranstoreRelocation(section);
  }

  function setHeights(section) {
    const root = document.documentElement;
    const announcement = document.querySelector('.announcement-bar-section');
    const heroHeader = section.querySelector('.header-hero-slideshow__header');

    if (announcement) {
      root.style.setProperty('--announcement-bar-height', `${announcement.offsetHeight}px`);
    }

    if (heroHeader) {
      root.style.setProperty('--header-hero-bar-height', `${heroHeader.offsetHeight}px`);
    }
  }

  function isHeroMobileHeader() {
    return window.matchMedia('(max-width: 989px)').matches;
  }

  function patchHeroTranstoreSelector() {
    const theme = window._transtore?.theme;
    if (!theme) return;

    if (isHeroMobileHeader()) {
      theme.selector_mobile = TRANSTORE_MOBILE_SELECTOR;
      if (Object.prototype.hasOwnProperty.call(theme, 'selector_embed_mobile')) {
        theme.selector_embed_mobile = TRANSTORE_MOBILE_SELECTOR;
      }
      return;
    }

    theme.selector_desktop = TRANSTORE_DESKTOP_SELECTOR;
  }

  function requestTranstoreRefresh() {
    patchHeroTranstoreSelector();

    const ts = window._transtore;
    if (!ts) return;

    if (typeof ts.reload === 'function') {
      ts.reload();
      return;
    }

    if (typeof ts.render === 'function') {
      ts.render();
      return;
    }

    if (typeof ts.initSwitcher === 'function') {
      ts.initSwitcher();
      return;
    }

    if (typeof ts.buildSwitcher === 'function') {
      ts.buildSwitcher();
    }
  }

  function nodeHasQikifyMenu(node) {
    return !!node?.querySelector?.('[class*="tmenu"]');
  }

  function resetHeroWidgetsToAnchor(section) {
    const anchorHeader = document.querySelector('.section-header .header');
    const heroHeader = section.querySelector('.header-hero-slideshow__header');
    if (!anchorHeader || !heroHeader) return;

    const anchorInline =
      anchorHeader.querySelector('.header__inline-menu .list-menu--inline') ||
      anchorHeader.querySelector('.list-menu.list-menu--inline');
    const anchorDrawer = anchorHeader.querySelector('.menu-drawer__menu');
    const heroDrawer = heroHeader.querySelector('.menu-drawer__menu');
    const anchorTranstore = anchorHeader.querySelector('[data-header-transtore-slot]');

    document
      .querySelectorAll(
        '.header-hero-slideshow__header [class*="tmenu_wrapper"], .section-header [class*="tmenu_wrapper"]'
      )
      .forEach((tmenu) => {
        if (!anchorInline || anchorInline.contains(tmenu)) return;
        safeAppendChild(anchorInline, tmenu);
      });

    if (heroDrawer && anchorDrawer && heroDrawer !== anchorDrawer) {
      Array.from(heroDrawer.children).forEach((child) => {
        if (nodeHasQikifyMenu(child)) safeAppendChild(anchorDrawer, child);
      });
    }

    if (anchorTranstore) {
      document.querySelectorAll('.header-hero-slideshow__header .ts-switcher-btn').forEach((btn) => {
        const node = btn.closest('.shopify-app-block, .ts-theme, .ts-switcher') || btn;
        safeAppendChild(anchorTranstore, node);
      });
    }

    heroHeader.querySelectorAll('.header__search').forEach((el) => el.style.removeProperty('display'));
    heroHeader
      .querySelectorAll('#ts-switcher-manual-mobile, #ts-switcher-manual-desktop, [data-header-transtore-slot]')
      .forEach((slot) => {
        slot.hidden = false;
        slot.removeAttribute('aria-hidden');
        slot.style.removeProperty('display');
        slot.style.removeProperty('width');
        slot.style.removeProperty('height');
        slot.style.removeProperty('overflow');
      });

    delete section.dataset.transtoreMobileMoved;
    restoreHeroDesktopLayout(section);
  }

  function rehydrateHeroForViewport(section) {
    const root = document.documentElement;

    resetHeroWidgetsToAnchor(section);
    releaseHeroScrollLock();
    patchHeroTranstoreSelector();
    syncCartIconId(section);

    if (isHeroMobileHeader()) {
      root.classList.remove(SOLID_CLASS, PINNED_CLASS, 'is-hero-header-spacer');
      root.style.removeProperty('--header-hero-sticky-top');
      syncHeroMobileHeader(section);
      return;
    }

    syncHeroDesktopHeader(section);
  }

  function syncHeroMobileHeader(section) {
    delete section.dataset.transtoreMobileMoved;

    ensureHeroMobileSearch(section);
    syncCartIconId(section);
    bootAnchorQikifyMenus();
    window.dispatchEvent(new CustomEvent('SETUP_MOBILEMENU'));
    syncHeroMobileMenu(section);
    relocateTranstoreSwitcherMobile(section);
    scheduleHeroMobileMenuSync(section);
    requestTranstoreRefresh();
  }

  function syncHeroDesktopHeader(section) {
    delete section.dataset.transtoreMobileMoved;

    restoreHeroDesktopLayout(section);
    bootAnchorQikifyMenus();
    window.dispatchEvent(new CustomEvent('SETUP_MEGAMENU'));
    window.dispatchEvent(new CustomEvent('SETUP_MOBILEMENU'));
    relocateQikifyMenu(section);
    relocateSearchIcon(section);
    relocateTranstoreSwitcher(section);
    initMobileHeroHeader(section);
    requestTranstoreRefresh();

    const heroHeader = section.querySelector('.header-hero-slideshow__header');
    if (heroHeader) {
      initMenuBarHover(section);
      syncHeroHeaderUtilityColors(heroHeader);
      scheduleNavColorSync(heroHeader);
    }
  }

  function scheduleHeroViewportRetries(section) {
    [100, 250, 750, 1500, 3000, 5000].forEach((delay) => {
      window.setTimeout(() => {
        if (!document.body.contains(section)) return;

        patchHeroTranstoreSelector();
        bootAnchorQikifyMenus();

        if (isHeroMobileHeader()) {
          syncHeroMobileMenu(section);
          relocateTranstoreSwitcherMobile(section);
          ensureHeroMobileSearch(section);
        } else {
          relocateQikifyMenu(section);
          relocateSearchIcon(section);
          relocateTranstoreSwitcher(section);
          restoreHeroDesktopLayout(section);

          const heroHeader = section.querySelector('.header-hero-slideshow__header');
          if (heroHeader) syncHeroHeaderUtilityColors(heroHeader);
        }

        requestTranstoreRefresh();
        setHeights(section);
      }, delay);
    });
  }

  function syncHeroForViewport(section) {
    const mode = isHeroMobileHeader() ? 'mobile' : 'desktop';
    const previousMode = section.dataset.heroViewportMode;

    if (previousMode === mode && section.dataset.heroViewportSynced === 'true') {
      setHeights(section);
      return;
    }

    section.dataset.heroViewportMode = mode;
    section.dataset.heroViewportSynced = 'true';

    rehydrateHeroForViewport(section);
    scheduleHeroViewportRetries(section);
  }

  function releaseHeroScrollLock() {
    document.body.classList.remove('overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden-desktop');
    document.documentElement.classList.remove('menu-open');

    document.querySelectorAll('.section-header, .header-hero-slideshow__header, .header-hero-slideshow-section').forEach((node) => {
      node.classList.remove('menu-open');
    });

    document.querySelectorAll('menu-drawer details[open]').forEach((details) => {
      if (!details.closest('.header-hero-slideshow__header, .section-header')) return;
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
      const summary = details.querySelector(':scope > summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    });

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus();
    }
  }

  const HERO_NAV_STYLE_ID = 'hero-header-qikify-nav-override';

  function isHeroMenuBarEngaged(heroHeader) {
    if (!heroHeader || isHeroMobileHeader()) return false;

    const root = document.documentElement;
    if (!root.classList.contains(ROOT_CLASS) || root.classList.contains(SOLID_CLASS)) {
      return false;
    }

    if (heroHeader.matches(':hover')) return true;

    const headerWrapper = heroHeader.querySelector('.header-wrapper');
    if (headerWrapper?.matches(':hover')) return true;

    const hoveredPanel = document.querySelector(`${MEGA_PANEL_SELECTOR}:hover`);
    if (!hoveredPanel) return false;

    const style = window.getComputedStyle(hoveredPanel);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    if (parseFloat(style.opacity) === 0) return false;

    return true;
  }

  function updateHeroMenuBarState(heroHeader) {
    if (!heroHeader || isHeroMobileHeader()) return;

    const engaged = isHeroMenuBarEngaged(heroHeader);
    heroHeader.classList.toggle('is-menu-bar-active', engaged);
    syncHeroHeaderUtilityColors(heroHeader);
  }

  function getHeroNavTargets(heroHeader) {
    return heroHeader.querySelectorAll(
      '.tmenu_item--root > .tmenu_item_link, .tmenu_item--root > .tmenu_item_link .tmenu_item_text'
    );
  }

  function injectHeroNavStylesheet() {
    let styleEl = document.getElementById(HERO_NAV_STYLE_ID);
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = HERO_NAV_STYLE_ID;
      document.head.appendChild(styleEl);
    } else {
      document.head.appendChild(styleEl);
    }

    styleEl.textContent = `
      @media screen and (min-width: 990px) {
        html.${ROOT_CLASS}:not(.${SOLID_CLASS}) .header-hero-slideshow__header:not(:hover):not(.is-menu-bar-active) .tmenu_item--root > .tmenu_item_link,
        html.${ROOT_CLASS}:not(.${SOLID_CLASS}) .header-hero-slideshow__header:not(:hover):not(.is-menu-bar-active) .tmenu_item--root > .tmenu_item_link .tmenu_item_text {
          color: rgb(255, 255, 255) !important;
          -webkit-text-fill-color: rgb(255, 255, 255) !important;
          fill: rgb(255, 255, 255) !important;
        }
        html.${ROOT_CLASS}:not(.${SOLID_CLASS}) .header-hero-slideshow__header:hover .tmenu_item--root > .tmenu_item_link,
        html.${ROOT_CLASS}:not(.${SOLID_CLASS}) .header-hero-slideshow__header:hover .tmenu_item--root > .tmenu_item_link .tmenu_item_text,
        html.${ROOT_CLASS}:not(.${SOLID_CLASS}) .header-hero-slideshow__header.is-menu-bar-active .tmenu_item--root > .tmenu_item_link,
        html.${ROOT_CLASS}:not(.${SOLID_CLASS}) .header-hero-slideshow__header.is-menu-bar-active .tmenu_item--root > .tmenu_item_link .tmenu_item_text {
          color: rgb(0, 0, 0) !important;
          -webkit-text-fill-color: rgb(0, 0, 0) !important;
          fill: rgb(0, 0, 0) !important;
        }
      }
    `;
  }

  const TRANSTORE_IDLE_VARS = {
    '--ts-btn-bg': 'transparent',
    '--ts-btn-text': 'rgb(255, 255, 255)',
    '--ts-text-color': 'rgb(255, 255, 255)',
    '--ts-icon-color': 'rgb(255, 255, 255)',
    '--ts-divider': 'rgba(255, 255, 255, 0.75)',
    '--ts-btn-border': 'none',
    '--ts-btn-box-shadow': 'none',
    '--ts-btn-bg-hover': 'transparent',
    '--ts-btn-text-hover': 'rgb(255, 255, 255)',
    '--ts-btn-bg-active': 'transparent',
    '--ts-btn-text-active': 'rgb(255, 255, 255)',
    '--ts-divider-hover': 'rgba(255, 255, 255, 0.75)',
    '--ts-divider-active': 'rgba(255, 255, 255, 0.75)',
  };

  const TRANSTORE_ACTIVE_VARS = {
    '--ts-btn-bg': 'transparent',
    '--ts-btn-text': 'rgb(0, 0, 0)',
    '--ts-text-color': 'rgb(0, 0, 0)',
    '--ts-icon-color': 'rgb(0, 0, 0)',
    '--ts-divider': 'rgba(0, 0, 0, 0.45)',
    '--ts-btn-border': 'none',
    '--ts-btn-box-shadow': 'none',
    '--ts-btn-bg-hover': 'transparent',
    '--ts-btn-text-hover': 'rgb(0, 0, 0)',
    '--ts-btn-bg-active': 'transparent',
    '--ts-btn-text-active': 'rgb(0, 0, 0)',
    '--ts-divider-hover': 'rgba(0, 0, 0, 0.45)',
    '--ts-divider-active': 'rgba(0, 0, 0, 0.45)',
  };

  function getHeroTranstoreRoots(heroHeader) {
    const roots = new Set();
    heroHeader.querySelectorAll('.ts-theme, .ts-switcher, .ts-switcher-btn').forEach((el) => roots.add(el));
    return roots;
  }

  function getHeroTranstoreTargets(heroHeader) {
    return heroHeader.querySelectorAll(
      '.ts-switcher-btn__name, .ts-currency__name, .ts-country__name, .ts-language__name, .ts-switcher-btn__icon-arrow, .ts-currency__icon-arrow, .ts-switcher-btn__icon svg, .ts-switcher-btn__icon-arrow svg, .ts-switcher-btn__divider svg'
    );
  }

  function applyTranstoreVars(target, vars) {
    Object.entries(vars).forEach(([key, value]) => {
      target.style.setProperty(key, value, 'important');
    });
    target.style.setProperty('background', 'transparent', 'important');
    target.style.setProperty('box-shadow', 'none', 'important');
    target.style.setProperty('border', 'none', 'important');
  }

  function clearTranstoreVars(target) {
    Object.keys(TRANSTORE_IDLE_VARS).forEach((key) => target.style.removeProperty(key));
    target.style.removeProperty('background');
    target.style.removeProperty('box-shadow');
    target.style.removeProperty('border');
    target.style.removeProperty('color');
  }

  function syncHeroTranstoreColors(heroHeader) {
    if (!heroHeader || isHeroMobileHeader()) return;

    const root = document.documentElement;
    const switchers = heroHeader.querySelectorAll('.ts-switcher-btn');
    const themeRoots = getHeroTranstoreRoots(heroHeader);

    if (!switchers.length && !themeRoots.size) return;

    const clearAllTranstoreInline = () => {
      themeRoots.forEach(clearTranstoreVars);
      switchers.forEach(clearTranstoreVars);
      getHeroTranstoreTargets(heroHeader).forEach((el) => {
        el.style.removeProperty('color');
        el.style.removeProperty('fill');
      });
      heroHeader.querySelectorAll('.ts-switcher-btn svg path').forEach((path) => {
        path.style.removeProperty('fill');
      });
    };

    if (!root.classList.contains(ROOT_CLASS) || root.classList.contains(SOLID_CLASS) || isHeroMobileHeader()) {
      clearAllTranstoreInline();
      return;
    }

    if (!isHeroMenuBarEngaged(heroHeader)) {
      clearAllTranstoreInline();
      return;
    }

    themeRoots.forEach((el) => applyTranstoreVars(el, TRANSTORE_ACTIVE_VARS));
    switchers.forEach((el) => applyTranstoreVars(el, TRANSTORE_ACTIVE_VARS));

    getHeroTranstoreTargets(heroHeader).forEach((el) => {
      el.style.setProperty('color', 'rgb(0, 0, 0)', 'important');
      if (el.tagName === 'svg' || el.tagName === 'path') {
        el.style.setProperty('fill', 'rgb(0, 0, 0)', 'important');
      }
    });

    heroHeader.querySelectorAll('.ts-switcher-btn svg path').forEach((path) => {
      path.style.setProperty('fill', 'rgb(0, 0, 0)', 'important');
    });
  }

  function syncHeroNavColors(heroHeader) {
    if (!heroHeader) return;

    injectHeroNavStylesheet();

    getHeroNavTargets(heroHeader).forEach((el) => {
      el.style.removeProperty('color');
      el.style.removeProperty('-webkit-text-fill-color');
      el.style.removeProperty('fill');
    });
  }

  function syncHeroHeaderUtilityColors(heroHeader) {
    syncHeroNavColors(heroHeader);
    syncHeroTranstoreColors(heroHeader);
  }

  function scheduleNavColorSync(heroHeader) {
    if (!heroHeader || isHeroMobileHeader()) return;
    const section = heroHeader.closest('[data-header-hero-slideshow]');
    [0, 100, 400, 800, 1500, 3000, 5000, 8000].forEach((delay) => {
      window.setTimeout(() => {
        if (section) relocateTranstoreSwitcher(section);
        updateHeroMenuBarState(heroHeader);
      }, delay);
    });
  }

  function initMenuBarHover(section) {
    const heroHeader = section.querySelector('.header-hero-slideshow__header');
    const headerWrapper = heroHeader?.querySelector('.header-wrapper');
    if (!heroHeader || !headerWrapper || heroHeader.dataset.menuBarHoverBound === 'true') return;

    heroHeader.dataset.menuBarHoverBound = 'true';

    let syncFrame;
    const boundPanels = new WeakSet();
    const megaPanelSelector = MEGA_PANEL_SELECTOR;

    function scheduleMenuBarSync() {
      window.cancelAnimationFrame(syncFrame);
      syncFrame = window.requestAnimationFrame(() => updateHeroMenuBarState(heroHeader));
    }

    function resetMenuBarActive() {
      window.cancelAnimationFrame(syncFrame);
      heroHeader.classList.remove('is-menu-bar-active');
      syncHeroHeaderUtilityColors(heroHeader);
    }

    heroHeader.resetMenuBarActive = resetMenuBarActive;
    heroHeader.syncHeroNavColors = () => syncHeroHeaderUtilityColors(heroHeader);

    function isMegaPanel(node) {
      return !!(node instanceof Element && node.closest(megaPanelSelector));
    }

    function isHeroBarTarget(node) {
      return !!(node instanceof Element && heroHeader.contains(node));
    }

    function bindPanel(panel) {
      if (!panel || boundPanels.has(panel)) return;
      boundPanels.add(panel);
      panel.addEventListener('mouseenter', scheduleMenuBarSync);
      panel.addEventListener('mouseleave', scheduleMenuBarSync);
    }

    function bindMegaPanels() {
      document.querySelectorAll(megaPanelSelector).forEach(bindPanel);
    }

    headerWrapper.addEventListener('mouseenter', scheduleMenuBarSync);
    headerWrapper.addEventListener('mouseleave', (event) => {
      if (isHeroBarTarget(event.relatedTarget) || isMegaPanel(event.relatedTarget)) return;
      scheduleMenuBarSync();
    });
    headerWrapper.addEventListener('focusin', scheduleMenuBarSync);
    headerWrapper.addEventListener('focusout', (event) => {
      if (headerWrapper.contains(event.relatedTarget) || isMegaPanel(event.relatedTarget)) return;
      scheduleMenuBarSync();
    });

    document.addEventListener('mouseover', (event) => {
      if (isHeroBarTarget(event.target) || isMegaPanel(event.target)) scheduleMenuBarSync();
    });

    document.addEventListener('mouseout', (event) => {
      const related = event.relatedTarget;
      if (isHeroBarTarget(related) || isMegaPanel(related)) return;
      if (isHeroBarTarget(event.target) || isMegaPanel(event.target)) scheduleMenuBarSync();
    });

    document.documentElement.addEventListener('mouseleave', resetMenuBarActive);

    bindMegaPanels();

    const observer = new MutationObserver(() => {
      bindMegaPanels();
      scheduleMenuBarSync();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    updateHeroMenuBarState(heroHeader);
    scheduleNavColorSync(heroHeader);
    watchQikifyStyleChanges(heroHeader);
    watchTranstoreStyleChanges(heroHeader);
  }

  function watchTranstoreStyleChanges(heroHeader) {
    if (heroHeader.dataset.transtoreStyleWatch === 'true') return;
    heroHeader.dataset.transtoreStyleWatch = 'true';

    const observer = new MutationObserver(() => {
      window.clearTimeout(heroHeader._transtoreSyncTimer);
      heroHeader._transtoreSyncTimer = window.setTimeout(() => {
        updateHeroMenuBarState(heroHeader);
      }, 50);
    });
    observer.observe(heroHeader, {
      childList: true,
      subtree: true,
    });
  }

  function watchQikifyStyleChanges(heroHeader) {
    if (heroHeader.dataset.qikifyStyleWatch === 'true') return;
    heroHeader.dataset.qikifyStyleWatch = 'true';

    function bindStyleObserver(styleEl) {
      if (!styleEl || styleEl.dataset.heroNavWatch === 'true') return;
      styleEl.dataset.heroNavWatch = 'true';
      new MutationObserver(() => syncHeroHeaderUtilityColors(heroHeader)).observe(styleEl, {
        childList: true,
        characterData: true,
        subtree: true,
      });
      syncHeroHeaderUtilityColors(heroHeader);
    }

    bindStyleObserver(document.getElementById('qikify-tmenu-custom-style'));

    new MutationObserver(() => {
      bindStyleObserver(document.getElementById('qikify-tmenu-custom-style'));
    }).observe(document.head, { childList: true, subtree: true });
  }

  function bootAnchorQikifyMenus() {
    const header = document.querySelector('.section-header .header');
    if (!header) return false;

    const desktopNav = header.querySelector('.list-menu.list-menu--inline');
    const mobileNav = header.querySelector('.menu-drawer__menu');
    if (!desktopNav || !mobileNav) return false;

    window.dispatchEvent(new CustomEvent('SETUP_MEGAMENU'));
    window.dispatchEvent(new CustomEvent('SETUP_MOBILEMENU'));
    return true;
  }

  function syncHeroMobileMenu(section) {
    const heroMenu = section.querySelector('.header-hero-slideshow__header .menu-drawer__menu');
    const sourceMenu = document.querySelector('.section-header .menu-drawer__menu');
    if (!heroMenu || !sourceMenu || heroMenu === sourceMenu) return false;
    if (nodeHasQikifyMenu(heroMenu)) return true;
    if (!nodeHasQikifyMenu(sourceMenu)) return false;

    Array.from(sourceMenu.children).forEach((child) => {
      safeAppendChild(heroMenu, child);
    });

    heroMenu.querySelectorAll(':scope > li').forEach((item) => {
      if (nodeHasQikifyMenu(item)) return;
      item.hidden = true;
      item.style.setProperty('display', 'none', 'important');
    });

    return nodeHasQikifyMenu(heroMenu);
  }

  function scheduleHeroMobileMenuSync(section) {
    function attempt() {
      bootAnchorQikifyMenus();
      return syncHeroMobileMenu(section);
    }

    if (attempt()) return;

    [250, 750, 1500, 3000, 5000].forEach((delay) => {
      window.setTimeout(attempt, delay);
    });
  }

  function initHeaderHeroSlideshow(section) {
    const root = document.documentElement;
    if (!root.classList.contains(ROOT_CLASS)) return;

    if (section.dataset.heroSlideshowBound !== 'true') {
      section.dataset.heroSlideshowBound = 'true';

      const heroHeader = section.querySelector('.header-hero-slideshow__header');
      const solidOffset = Number(section.dataset.solidOffset || 24);
      let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

      function updateScrollState() {
        setHeights(section);

        if (isHeroMobileHeader()) {
          root.classList.remove(SOLID_CLASS, PINNED_CLASS, 'is-hero-header-spacer');
          root.style.removeProperty('--header-hero-sticky-top');
          return;
        }

        const announcementEl = document.querySelector('.announcement-bar-section');
        const announcementBottom = announcementEl ? announcementEl.getBoundingClientRect().bottom : 0;
        const stickyTop = Math.max(0, Math.round(announcementBottom));

        root.style.setProperty('--header-hero-sticky-top', `${stickyTop}px`);

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > solidOffset) {
          root.classList.add(SOLID_CLASS);
          root.classList.add(PINNED_CLASS);
        } else {
          root.classList.remove(SOLID_CLASS);
          root.classList.remove(PINNED_CLASS);
        }

        if (scrollTop !== lastScrollTop) {
          lastScrollTop = scrollTop;
          if (heroHeader && typeof heroHeader.resetMenuBarActive === 'function') {
            heroHeader.resetMenuBarActive();
          }
        }

        root.classList.remove('is-hero-header-spacer');

        if (heroHeader && typeof heroHeader.syncHeroNavColors === 'function') {
          heroHeader.syncHeroNavColors();
        }
      }

      updateScrollState();
      window.addEventListener('scroll', updateScrollState, { passive: true });
      window.addEventListener('resize', () => {
        setHeights(section);
      });
      scheduleTranstoreRelocation(section);

      window.addEventListener('load', () => {
        delete section.dataset.heroViewportSynced;
        syncHeroForViewport(section);
      });
      window.addEventListener('pageshow', () => {
        delete section.dataset.heroViewportSynced;
        syncHeroForViewport(section);
      });
      document.addEventListener('shopify:section:load', updateScrollState);
      document.addEventListener('shopify:section:unload', updateScrollState);
    }

    syncHeroForViewport(section);
  }

  function bindGlobalHeroViewportSync() {
    if (window.__heroViewportGlobalBound) return;
    if (!document.documentElement.classList.contains(ROOT_CLASS)) return;

    window.__heroViewportGlobalBound = true;

    const mq = window.matchMedia('(max-width: 989px)');

    mq.addEventListener('change', () => {
      // Qikify + Transtore only initialize correctly on full page load for the
      // active breakpoint. DOM moves between hero/anchor headers cannot replicate
      // a refresh, so reload when crossing the hero mobile/desktop breakpoint.
      if (window.Shopify && window.Shopify.designMode) {
        document.querySelectorAll('[data-header-hero-slideshow]').forEach((section) => {
          delete section.dataset.heroViewportSynced;
          rehydrateHeroForViewport(section);
          scheduleHeroViewportRetries(section);
        });
        return;
      }

      window.location.reload();
    });
  }

  function patchHeroHeaderDrawer() {
    if (window.__heroHeaderDrawerPatched) return;

    const HeaderDrawerClass = customElements.get('header-drawer');
    if (!HeaderDrawerClass) return;

    window.__heroHeaderDrawerPatched = true;
    const proto = HeaderDrawerClass.prototype;
    const MenuDrawerProto = Object.getPrototypeOf(proto);
    const originalOpen = proto.openMenuDrawer;
    const originalClose = proto.closeMenuDrawer;
    const originalResize = proto.onResize;
    const originalFocusOut = proto.onFocusOut;

    function isHeroDrawer(drawer) {
      return drawer instanceof HeaderDrawerClass && !!drawer.closest('[data-header-hero-slideshow]');
    }

    function getHeroHeaderNodes(drawer) {
      return {
        section: drawer.closest('.header-hero-slideshow-section'),
        header: drawer.closest('.header-hero-slideshow__header'),
      };
    }

    function setHeroHeaderBottomPosition(drawer) {
      const { header } = getHeroHeaderNodes(drawer);
      const borderOffset =
        drawer.borderOffset ??
        (drawer.closest('.header-wrapper')?.classList.contains('header-wrapper--border-bottom') ? 1 : 0);
      drawer.borderOffset = borderOffset;
      if (!header) return;

      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(header.getBoundingClientRect().bottom - borderOffset, 10)}px`
      );
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    }

    proto.openMenuDrawer = function (summaryElement) {
      if (!isHeroDrawer(this)) {
        return originalOpen.call(this, summaryElement);
      }

      const { section, header } = getHeroHeaderNodes(this);
      this.header = section || header;
      this.borderOffset =
        this.borderOffset ??
        (this.closest('.header-wrapper')?.classList.contains('header-wrapper--border-bottom') ? 1 : 0);

      setHeroHeaderBottomPosition(this);
      document.querySelector('.section-header')?.classList.remove('menu-open');
      this.header?.classList.add('menu-open');
      header?.classList.add('menu-open');

      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      });

      summaryElement.setAttribute('aria-expanded', true);
      window.addEventListener('resize', this.onResize);
      trapFocus(this.mainDetailsToggle, summaryElement);
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    };

    proto.closeMenuDrawer = function (event, elementToFocus) {
      if (!isHeroDrawer(this)) {
        return originalClose.call(this, event, elementToFocus);
      }

      // Keep Dawn's guards: focusout calls closeMenuDrawer() with no args.
      // Filling those in made iOS Safari close the whole drawer when tapping
      // Qikify accordion rows (non-focusable controls move activeElement to body).
      if (event === undefined || !elementToFocus) return;

      MenuDrawerProto.closeMenuDrawer.call(this, event, elementToFocus);

      const { header } = getHeroHeaderNodes(this);
      this.header?.classList.remove('menu-open');
      header?.classList.remove('menu-open');
      elementToFocus.setAttribute('aria-expanded', 'false');
      window.removeEventListener('resize', this.onResize);
    };

    proto.onFocusOut = function () {
      if (!isHeroDrawer(this)) {
        return originalFocusOut ? originalFocusOut.call(this) : undefined;
      }

      setTimeout(() => {
        if (!this.mainDetailsToggle?.hasAttribute('open')) return;

        const active = document.activeElement;
        if (active && this.mainDetailsToggle.contains(active)) return;

        // iOS often leaves focus on body/html after tapping accordion toggles.
        if (!active || active === document.body || active === document.documentElement) return;

        const summary = this.mainDetailsToggle.querySelector('summary');
        if (summary) this.closeMenuDrawer(new Event('focusout'), summary);
      });
    };

    proto.onResize = function () {
      if (isHeroDrawer(this)) {
        setHeroHeaderBottomPosition(this);
        return;
      }
      return originalResize.call(this);
    };
  }

  function ensureHeroHeaderDrawerPatch() {
    patchHeroHeaderDrawer();
    if (!window.__heroHeaderDrawerPatched) {
      window.addEventListener('load', patchHeroHeaderDrawer, { once: true });
    }
  }

  function clearRootClasses() {
    const root = document.documentElement;
    if (document.querySelector('[data-header-hero-slideshow]')) return;

    root.classList.remove(ROOT_CLASS, SOLID_CLASS, PINNED_CLASS, 'is-hero-header-spacer');
  }

  function boot() {
    ensureHeroHeaderDrawerPatch();
    releaseHeroScrollLock();
    bindGlobalHeroViewportSync();
    document.querySelectorAll('[data-header-hero-slideshow]').forEach(initHeaderHeroSlideshow);

    window.__rehydrateHeroHeaderForViewport = function (options) {
      if (options && options.reload) {
        window.location.reload();
        return { reloading: true };
      }

      document.querySelectorAll('[data-header-hero-slideshow]').forEach((section) => {
        delete section.dataset.heroViewportSynced;
        rehydrateHeroForViewport(section);
        scheduleHeroViewportRetries(section);
      });

      return {
        mode: isHeroMobileHeader() ? 'mobile' : 'desktop',
        sections: document.querySelectorAll('[data-header-hero-slideshow]').length,
        heroTmenu: !!document.querySelector('.header-hero-slideshow__header [class*="tmenu_wrapper"]'),
        heroTranstore: !!document.querySelector('.header-hero-slideshow__header .ts-switcher-btn'),
        tip: 'Crossing mobile/desktop requires a reload. Run __rehydrateHeroHeaderForViewport({ reload: true })',
      };
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:unload', clearRootClasses);
  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('pageshow', releaseHeroScrollLock);
})();
